export default function referenceLinkOption(item, escape) {
  if (item.author !== null && item.author !== undefined) {
    return `<div class="p-1">${escape(item.title)} <small>(${escape(item.author)})</small></div>`;
  }
  return `<div class="p-1">${escape(item.title)}</div>`;
}
